import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import {getSharedSmartChipProps, SharedSmartChipProps} from 'ui-library/chips/ChipUtil';
import {apiIdToIconName} from 'util/APIUtil';

import BenchChip from './BenchChip';
import SmartChip from './SmartChip';
import useSmartChipQuery, {SmartChipType} from './useSmartChipQuery';

export default function DocumentChip(props: SharedSmartChipProps<SmartChipType.DOCUMENT>): JSX.Element {
  const sharedSmartChipProps = getSharedSmartChipProps(props);
  const {id, onClick} = sharedSmartChipProps;

  const {
    item: document,
    handleClickLink,
    isInaccessible,
    itemUrl: documentUrl,
  } = useSmartChipQuery<SmartChipType.DOCUMENT>({
    id,
    onClick,
    getUrlFn: ({editUrl}) => editUrl,
  });

  // If we have the document and its parent ID, delegate to BenchChip with the parent ID.
  // Hide secondary text since the parent's name (e.g., worksheet) may already include its displayId.
  if (BenchlingConfig.ELN_ENABLE_DOCUMENT_NOTE_REFERENCES && document?.parentId) {
    return <BenchChip {...sharedSmartChipProps} id={document.parentId} hideSecondaryText={true} />;
  }

  return (
    <SmartChip
      {...sharedSmartChipProps}
      icon={document != null ? apiIdToIconName(document.id) : null}
      isInaccessible={isInaccessible}
      item={document}
      onClick={handleClickLink}
      url={documentUrl}
    />
  );
}
